import { render } from "./CognitoCallbackView.vue?vue&type=template&id=5057ee7a&ts=true"
import script from "./CognitoCallbackView.vue?vue&type=script&lang=ts"
export * from "./CognitoCallbackView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__